module.exports = __webpack_public_path__ + "static/media/checkBoxTrue.3dd57301.svg";